// extracted by mini-css-extract-plugin
module.exports = {"step":"_3RDEW2gKviZi","text":"_3MPVqD1txsWy","icon":"_1lWh5dXFyKPU"};